import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sick-day",
  "use": "sick-day-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"sick-day\"><path d=\"M5.913 10.087H0V5.913h5.913V0h4.174v5.913H16v4.174h-5.913V16H5.913z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol